import styled from "styled-components";
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';

export const CardHeaderStyled = styled(({ ...props }) => (
    <CardHeader {...props} />
))`
    && {
        padding: 8px 16px; 
    }
`;

export const ListStyled = styled(({ ...props }) => (
    <List dense component="div" role="list" {...props} />
))`
    && {
        width: 100%;
        height: 230px;
        background-color: #FFFFFF;
        overflow: auto;
    }
`;
